import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Music2: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '8', cy: '18', r: '4' }],
    ['path', { d: 'M12 18V2l7 4' }],
  ],
];

export default Music2;
